import Sentry from "@similarweb/sentry-logger";

import type { SWSettings } from "app/common/services/swSettings";
import {
    isAfterTrial,
    isReactivatedInTrial,
    isNoTouch,
    isSI,
    isCCTrialUser,
    isTraditionalTrialUser,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export enum FlowEventName {
    FLOW_STARTED = "flow_started",
    FLOW_COMPLETED = "flow_completed",
    FLOW_SKIPPED = "flow_skipped",
    FLOW_ABORTED = "flow_aborted",
}

export enum StepEventName {
    STEP_STARTED = "step_started",
    STEP_COMPLETED = "step_completed",
    STEP_SKIPPED = "flow_skipped",
    STEP_ABORTED = "flow_aborted",
}

let isIdentified = false;

export const initAppcues = (swSettings: SWSettings) => {
    if (window.location.host?.includes("sandbox") || !window.Appcues) {
        return;
    }
    try {
        // Clears all known information about the current user in this session.
        window.Appcues?.reset();
        const shouldAppcuesInject = !!swSettings?.components?.Home?.resources?.ShouldAppcuesInject;
        const isAfterTrialUser = isAfterTrial(swSettings); // a patch for fixing wrong AppcuesInjected claim to After Trial users
        if (shouldAppcuesInject && !isAfterTrialUser) {
            const { id: userId, accountId, username: email, createDate, plan, userRole } = swSettings.user;
            const creationDate = new Date(createDate);
            const isDashboardExists = !!window.similarweb?.config?.userData?.dashboards?.length;
            const isKeywordsListExists = !!window.similarweb?.config?.userData?.keywordGroups?.length;
            const isCCUser = isCCTrialUser(swSettings);
            const isReactivatedCCUser = isReactivatedInTrial(swSettings);
            const isNoTouchUser = isNoTouch(swSettings);
            const isTrialUser = isTraditionalTrialUser(swSettings);
            const isSIUser = isSI(swSettings);

            // Identifies the current user with an ID and an optional set of properties.
            window.Appcues?.identify(userId, {
                email,
                plan,
                accountId,
                userRole,
                createDate: creationDate,
                isDashboardExists,
                isKeywordsListExists,
                isCCUser,
                isReactivatedCCUser,
                isNoTouchUser,
                isTrialUser,
                isSIUser,
            });
            isIdentified = true;

            window.Appcues?.track("Site Visit");
        }
    } catch (error) {
        Sentry.error(`Appcues Init Error - ` + JSON.stringify(error), error as Error);
    }
};

export const trackEvent = (eventName: string, eventAttributes?: Record<string, unknown>) => {
    if (isIdentified) {
        window.Appcues?.track(eventName, eventAttributes);
    }
};
